import React from "react";
import "./AllServices.css";

export default function AllServices() {
  return (
    <div className="services-wrapper">
        <h1 className="section-title">All Services</h1>
      {/* SERVICE PAGE 1 */}
      <section className="service-block">
        <h1>End-to-End Staffing & Workforce Management Across India</h1>
        <p>
          Adamant HR provides flexible, scalable, and 100% compliant staffing solutions across industries.
          We deploy skilled, semi-skilled, and unskilled manpower with a complete lifecycle management
          system covering hiring, onboarding, attendance, payroll, compliance, and replacement.
        </p>

        <h3>Our Staffing Expertise</h3>
        <ul>
          <li>Contractual & project-based staffing</li>
          <li>Pan-India manpower supply</li>
          <li>Sales, field, operations & back-office teams</li>
          <li>Plant, warehouse & logistics workforce</li>
          <li>Temporary staffing for seasonal / bulk needs</li>
        </ul>

        <h3>Why Clients Prefer Us</h3>
        <ul>
          <li>Zero-error documentation</li>
          <li>Verified manpower</li>
          <li>Fast replacement support</li>
          <li>Transparent MIS reporting</li>
          <li>Multi-location delivery</li>
          <li>Dedicated key account manager</li>
        </ul>
      </section>

      {/* SERVICE PAGE 2 */}
      <section className="service-block">
        <h1>India’s Premier Talent Partner for High-Quality Hiring</h1>
        <p>
          Adamant HR delivers high-performance recruitment services with dedicated sourcing teams across
          BFSI, NBFC, FMCG, Manufacturing, Retail, and IT.
        </p>

        <h3>Recruitment Capabilities</h3>
        <ul>
          <li>Entry to Senior-Level Hiring</li>
          <li>Sales, Operations, Tech & Leadership Hiring</li>
          <li>Volume Hiring for NBFC/BFSI</li>
          <li>Plant & Technical Recruitment</li>
          <li>Campus Hiring</li>
        </ul>

        <h3>What Makes Our Recruitment Unique</h3>
        <ul>
          <li>72-hour TAT for most roles</li>
          <li>Verified candidate pipeline</li>
          <li>Role-based interview evaluation</li>
          <li>High joining ratio</li>
          <li>Industry-experienced recruiters</li>
        </ul>
      </section>

      {/* SERVICE PAGE 3 */}
      <section className="service-block">
        <h1>100% Statutory-Compliant Payroll & HR Outsourcing</h1>
        <p>
          We manage end-to-end payroll, statutory filings, audits, and labour compliance for clients across India.
        </p>

        <h3>Our Capabilities</h3>
        <ul>
          <li>Payroll processing</li>
          <li>PF, ESIC, LWF, PT, CLRA registration</li>
          <li>Monthly statutory challans</li>
          <li>Digital payslips & MIS reports</li>
          <li>Full compliance audits</li>
          <li>Labour law documentation</li>
        </ul>
      </section>

      {/* SERVICE PAGE 4 */}
      <section className="service-block">
        <h1>Trusted Background Checks for a Safe & Reliable Workforce</h1>
        <h3>Verification Services</h3>
        <ul>
          <li>Employment Verification</li>
          <li>Education Verification</li>
          <li>Address Verification</li>
          <li>Criminal/Court Checks</li>
          <li>ID Checks (PAN, Aadhaar)</li>
          <li>Reference Checks</li>
        </ul>

        <h3>Why Choose Our BGV Services</h3>
        <ul>
          <li>Fast TAT</li>
          <li>Verified documentation</li>
          <li>Zero-error reports</li>
          <li>Essential for BFSI/NBFC</li>
        </ul>
      </section>

      {/* SERVICE PAGE 5 */}
      <section className="service-block">
        <h1>Professional Security & Facility Management</h1>
        <h3>Services</h3>
        <ul>
          <li>Security Guards & Supervisors</li>
          <li>Office & Building Facility Management</li>
          <li>Housekeeping & Maintenance</li>
          <li>Attendance & Discipline Management</li>
        </ul>
      </section>

      {/* SERVICE PAGE 6 */}
      <section className="service-block">
        <h1>Compassionate Home Nursing, Attendants & Elderly Care</h1>
        <p>A dedicated healthcare vertical providing trained attendants, patient care staff, and senior citizen support.</p>
      </section>

      {/* SERVICE PAGE 7 */}
      <section className="service-block">
        <h1>Affordable, Fast & Reliable Legal and Trademark Services</h1>
        <ul>
          <li>Trademark Registration</li>
          <li>Copyright & Patent Support</li>
          <li>HR Agreements, Notices, NDAs</li>
          <li>Labour law advisory</li>
        </ul>
      </section>

      {/* SERVICE PAGE 8 */}
      <section className="service-block">
        <h1>Turnkey Construction, Renovation & Civil Work Services</h1>
        <ul>
          <li>Residential & commercial construction</li>
          <li>Renovation & interiors</li>
          <li>Civil development & boundary walls</li>
          <li>Site supervision and material management</li>
        </ul>
      </section>
    </div>
  );
}

/* ---------------- CSS (AllServices.css) ---------------- */
